
export const CLEAR_CATEGORY_SLUG = "CLEAR_CATEGORY_SLUG";
export const SET_CATEGORY_SLUG = "SET_CATEGORY_SLUG";
export const SET_IS_DYNAMIC = 'SET_IS_DYNAMIC';
export const NOT_IS_DYNAMIC = 'NOT_IS_DYNAMIC';



export const clearCategorySlug = () => {
  return {
    type: CLEAR_CATEGORY_SLUG,
  };
};

export const setCategorySlug = (slug) => {
  return {
    type: SET_CATEGORY_SLUG,
    payload: slug ,  
  };
};
export const setIsDynamic = (isDynamic) => ({
  type: SET_IS_DYNAMIC,
  payload: isDynamic,  // directly set the value of isDynamic
});

// Action to unset isDynamic
export const unsetDynamic = () => ({
  type: NOT_IS_DYNAMIC,
});